export default function GlitchText({ as: Tag = 'span', children, className = '', ...rest }) {
  const text = typeof children === 'string' ? children : '';
  return (
    <Tag className={`glitch ${className}`.trim()} data-text={text} {...rest}>
      {children}
    </Tag>
  );
}
